export const environment = {
  password: "Q3StX&V20zLF",
  hostURL: "https://nycha.aecomshift.com/",
  stage: "staging",
  blobPhotos: 'https://planspendstorage1.blob.core.windows.net/nychaimages/',
  projectPhotos: "https://planspendstorage1.blob.core.windows.net/nychaprojects/",
  defaultDevelopmentPhoto: '/assets/img/bg/project-background.png',
  defaultPhotoPhoto: "/assets/img/bg/no-project.svg",
  Average20YearCapitalNeeds: 533750.22,
  googleTranslatorLocation: "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit",
  apiUrl: 'https://nycha-api.aecomshift.com'
};
